import * as React from 'react';
import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google';
import Button from '@mui/material/Button';
import { GoogleIcon } from '../CustomIcons';
import Service from '../../../util/Service';
import { ACCESS_TOKEN, time_cache } from '../Login'; // Reutiliza as constantes do seu Login

// Substitua pela sua chave do Google Cloud Console ou vinda de variável de ambiente (import.meta.env ou process.env)
const GOOGLE_CLIENT_ID = '459728464490-nvv1dtlncfdnloqor8p05pu8g7otor0r.apps.googleusercontent.com';


function GoogleLoginContent({ onLoginError }) {
  const loginWithGoogle = useGoogleLogin({
    flow: 'auth-code', 
    onSuccess: async (codeResponse) => {
      try {
        const authorizationCode = codeResponse.code; 

        if (!authorizationCode) {
          console.error('Código do Google veio nulo/undefined:', codeResponse);
          onLoginError('Falha ao obter código de autorização.');
          return;
        }

        const response = await Service.LOGIN('/api/login/google', {
          code: authorizationCode,
        });

        if (response.accessToken) {
          localStorage.removeItem('pageRoot');
          localStorage.setItem(ACCESS_TOKEN, response.accessToken);

          const profile = await Service.GET('/api/security/profile');
          profile.timeout = time_cache + new Date().getTime();
          sessionStorage.setItem('profile', JSON.stringify(profile));

          setTimeout(() => {
            const page = localStorage.getItem('page');
            window.location.href = page && page !== '/login' ? page : '/';
          }, 800);
        } else {
          onLoginError('Acesso negado via Google.');
        }
      } catch (error) {
        console.error('Erro no login com Google:', error);
        onLoginError('Acesso negado!');
      }
    },
    onError: (errorResponse) => {
      console.error('Falha na autenticação do Google:', errorResponse);
      onLoginError('Falha ao autenticar com o Google.');
    },
  });

  return (
    <Button
      fullWidth
      variant="outlined"
      onClick={() => loginWithGoogle()}
      startIcon={<GoogleIcon />}
    >
      Logar com Google
    </Button>
  );
}

export default function GoogleLogin({ onLoginError }) {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <GoogleLoginContent onLoginError={onLoginError} />
    </GoogleOAuthProvider>
  );
}